// Native
import { useState } from "react"

// Components
import { Button, ButtonGroup, Divider, Flex, HStack, Image, ModalBody, ModalFooter, Stack, Text, useDisclosure, useToast } from "@chakra-ui/react"
import { Alert, Form, Modal, Show } from "components"

// Config
import { API, Mask } from "config"

// Screens
import { Authenticate } from "screens"

// Assets
const receita_federal = require('assets/png/receita-federal.png')

export default function Company({ data:distributor, ...props }){

    const toast = useToast()
    const [ form, setForm ] = useState({ doc_cnpj: Mask.cnpj(distributor.data?.doc_cnpj) })
    const [ errors, setErrors ] = useState()
    const [ loading, setLoading ] = useState(false)
    const [ cnpj, setCNPJ ] = useState()

    const auth = useDisclosure()

    const onChange = ({ target }) => {
        const { name, value } = target
        switch(name){
            case 'doc_cnpj': setForm({...form, [name]: Mask.cnpj(value)}); setCNPJ(null); break;
            default: setForm({...form, [name]: value}); break;
        }
    }

    const searchCNPJ = async (doc_cnpj) => {
        setLoading(true)

        try{
            const callback = await API.get(`/ext/cnpj/${doc_cnpj.replace("/", '')}`)

            setCNPJ(callback.data)
            
            const company = {
                company_name: callback.data?.['RAZAO SOCIAL'],
                dob: callback.data?.['DATA ABERTURA'],
                address_line_1: callback.data?.['TIPO LOGRADOURO'] + ' ' + callback.data?.['LOGRADOURO'],
                address_complement: callback.data?.['COMPLEMENTO'] ?? null,
                address_number: callback.data?.['NUMERO'],
                address_neighborhood: callback.data?.['BAIRRO'],
                zip: callback.data?.['CEP'],
                doc_cnpj
            }

            setForm({...form, ...company })

            toast({ description: 'Dados do CNPJ foram preenchidos automaticamente.', position: 'bottom-right', status: 'success' })
        }catch(err){
            toast({ description: 'Não foi possível localizar informações sobre o CNPJ informado.', position: 'bottom-right' })
        }

        setLoading(false)
    }

    const handleSubmit = async () => {
        setLoading(true)

        try{
            await API.put(`/distributors/${distributor.data?.id}`, form)
            toast({ title: 'Dados fiscais atualizados', status: 'info' })
            distributor.refetch()
            setForm({})
            setCNPJ(null)
            props.onClose()
        }catch(err){
            setErrors(err?.response?.data?.errors)
            toast({ title: 'Não foi possível atualizar os dados fiscais', description: err?.response?.data?.message })
        }

        setLoading(false)
    }

    return(
    <>
    <Modal {...props}>
        <ModalBody>
            <Stack spacing={6}>
                <Flex direction="column" alignItems="center" >
                    <Image src={receita_federal} h={120} />
                    <Text fontSize="lg" children="Atualização de dados fiscais" mt={2} />
                </Flex>

                <Divider />

                <Form.Form onSubmit={auth.onOpen}>

                    <Alert children="As informações fiscais podem não estar atualizadas ou não encontrar alguns CNPJ's." />

                    <Form.Text
                        required
                        label="CNPJ:"
                        name="doc_cnpj"
                        value={form?.doc_cnpj}
                        error={errors?.doc_cnpj}
                        isDisabled={loading}
                        onChange={onChange}
                        placeholder="Ex.: 123.123.257/0001-00"
                        size="lg"
                        fontWeight="bold"
                    />

                    <Show visible={!cnpj}>
                        <Button size="sm" colorScheme="orange" isDisabled={loading} onClick={() => searchCNPJ(form?.doc_cnpj)} children="Buscar informações do CNPJ" />
                    </Show>

                    <Show visible={!!cnpj}>

                        <Form.Text
                            required
                            label="Inscrição Estadual (IE):"
                            name="doc_ie"
                            value={form?.doc_ie}
                            error={errors?.doc_ie}
                            defaultValue={distributor.data?.doc_ie}
                            onChange={onChange}
                            isDisabled={loading}
                            size="sm"
                        />

                        <Form.Text
                            required
                            label="Razão Social:"
                            name="company_name"
                            value={form?.company_name}
                            error={errors?.company_name}
                            defaultValue={distributor.data?.company_name}
                            onChange={onChange}
                            isDisabled={loading}
                            size="sm"
                        />

                        <Form.Text
                            required
                            label="Data de abertura da empresa:"
                            name="dob"
                            value={form?.dob}
                            error={errors?.dob}
                            onChange={onChange}
                            isDisabled={loading}
                            size="sm"
                        />

                        <Form.Text
                            required
                            label="Endereço (Linha 1)"
                            name="address_line_1"
                            value={form?.address_line_1}
                            error={errors?.address_line_1}
                            onChange={onChange}
                            isDisabled={loading}
                            size="sm"
                        />

                        <Form.Text
                            label="Endereço (Linha 2):"
                            name="address_line_2"
                            value={form?.address_line_2}
                            error={errors?.address_line_2}
                            onChange={onChange}
                            isDisabled={loading}
                            size="sm"
                        />

                        <HStack>
                            <Form.Text
                                required
                                label="Bairro/Setor:"
                                name="address_neighborhood"
                                value={form?.address_neighborhood}
                                error={errors?.address_neighborhood}
                                onChange={onChange}
                                isDisabled={loading}
                                size="sm"
                            />

                            <Form.Text
                                required
                                label="Código Postal (CEP):"
                                name="zip"
                                value={form?.zip}
                                error={errors?.zip}
                                onChange={onChange}
                                isDisabled={loading}
                                size="sm"
                            />
                        </HStack>

                        <HStack>
                            <Form.Text
                                required
                                label="Número:"
                                name="address_number"
                                value={form?.address_number}
                                error={errors?.address_number}
                                onChange={onChange}
                                isDisabled={loading}
                                size="sm"
                            />

                            <Form.Text
                                label="Complemento:"
                                name="address_complement"
                                value={form?.address_complement}
                                error={errors?.address_complement}
                                onChange={onChange}
                                isDisabled={loading}
                                size="sm"
                            />
                        </HStack>

                    </Show>

                </Form.Form>
            </Stack>
        </ModalBody>
        <ModalFooter>
            <ButtonGroup size="sm" isDisabled={loading}>
                <Button isDisabled={!cnpj} isLoading={loading} onClick={auth.onOpen} children="Atualizar dados" />
                <Button colorScheme="red" children="Cancelar" onClick={props.onClose} />
            </ButtonGroup>
        </ModalFooter>
    </Modal>

    <Authenticate {...auth} onSuccess={handleSubmit} />
    </>
    )
}